module.exports = __webpack_public_path__ + "assets/img/portfolio-antras.4376a5aa.jpg";